import { Dialog } from '@angular/cdk/dialog';
import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  signal
} from '@angular/core';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';

import { MediaQueryService } from '@app/@core/breakpoints';
import { PreloadRectComponent } from '@app/@core/common/directives';
import { AuthState } from '@app/modules/users';
import { HowItWorksDialog } from '@app/modules/users/dialogs';
import { WithdrawalsState } from '@app/modules/withdrawals';
import { NumberPipe } from '@core/common/pipes';
import { indicateLoading } from '@core/helpers';

import { WithdrawalsItemComponent } from './withdrawals-item/withdrawals-item.component';

@Component({
  selector: 'withdrawals-table',
  templateUrl: './withdrawals.component.html',
  styleUrl: './withdrawals.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NumberPipe,
    PreloadRectComponent,
    WithdrawalsItemComponent
  ]
})
export default class WithdrawalsTableComponent {
  public readonly authState = inject(AuthState);
  public readonly withdrawalsState = inject(WithdrawalsState);

  private readonly dialog = inject(Dialog);
  private readonly destroyRef = inject(DestroyRef);
  private readonly mediaService = inject(MediaQueryService);
  public readonly isLoading = signal<boolean>(false);
  public readonly isLg = toSignal(this.mediaService.mediaQuery('max', 'lg'));

  constructor() {
    this.loadWithdrawals();
  }

  public readonly preloadRows = new Array(10);

  openNeedPlayGamesDialog(): void {
    this.dialog.open(HowItWorksDialog);
  }

  private loadWithdrawals(): void {
    this.withdrawalsState
      .loadWithdrawals()
      .pipe(indicateLoading(this.isLoading), takeUntilDestroyed(this.destroyRef))
      .subscribe();
  }
}
